const contactValueGetter = (props) => {
  const { value } = props

  if (!value) {
    return ''
  }
  let concatString = ''
  value.forEach((item) => (concatString += item?.value + '\r\n'))
  return concatString
}

export default contactValueGetter
